<template>
<span class="avatar avatar-sm rounded-circle">
                               <avatar :fullname="$store.getters['authentication/name']" :size=36
                                       color="#172b4d"></avatar>
                            </span>
</template>
<script>
    import Avatar from 'vue-avatar-component'

    export default {
        name: 'SocialguardAvatar',
        components: {Avatar}
    }
</script>